import React, { useEffect, useState  } from 'react';
import {  Select,Card,DatePicker,Button,Table,IconDownload } from "@veneer/core";
import { Col, Row } from "react-bootstrap";
import ConnectAPI from '../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { numberFormatComma } from '../../common/js/utils/numberFormat';
import { downloadFile } from '../../services/FileDownloader/FileDownloader';
import XLSX from 'xlsx';
const InventorReport=({data})=>{
    const connectApi = new ConnectAPI();
    const [selectelement, setselectelemen]=useState([]);
    const [customer,setcustomer]=useState()
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [Clickinventory, setClickinventory]=useState();
    const [inload, setinload]=useState(false);
    const [headertable, setheadertable]=useState([]);
    const [datatable,setdatatable]=useState([]);
   
    const handleOnDateChange3 = (newDates) => {
        const {
            startDate: newStartDate,
            endDate: newEndDate,
        } = newDates;
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };
    
    useEffect(()=>{
        var elemen=[];
        data.forEach(x=>{
            var item={value:x.idCustomer, label:x.customerName};
            elemen.push(item);
        }); 
        setselectelemen(elemen);
    },[data])
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
     const downloadReport = () => {
        const reportData = datatable;
        const ws = XLSX.utils.json_to_sheet(reportData);
        const wb = XLSX.utils.book_new();
        const now = moment(new Date()).format("YYYYMMDDHHmm");
        const fileName = `Inventory Report - ${now} - .xlsx`;
        XLSX.utils.book_append_sheet(wb, ws, "Report");
        XLSX.writeFile(wb, fileName);
    }
    const report=()=>{
            setinload(true);
            setdatatable([]);
            setheadertable([]);
            
            var param={
                'Startdate':moment(startDate).format('YYYY-MM-DD'),
                'Enddate':moment(endDate).format('YYYY-MM-DD'),
                'InventoryClick':Clickinventory,
                'IdCustomer':customer
            }

            if (startDate == endDate){
                Swal.fire(
                    "Error ",
                    "Start Date and End Date is the same date",
                    "error"
                );  
                return false;
            }
            connectApi.getWithParams("api/Channels/getinventoryreport",param , consolid)
            .catch((error) => {
                setinload(false);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            })
        }
        const consolid=(status, data)=>{
            setinload(false);
            if (data.length==0){
                Swal.fire(
                    "No Data Result" ,
                    "",
                    "info"
                );
                return false;
            }
            var PeriodFilter=data.map(item=>item.period).filter(onlyUnique).sort((a, b) => new Date(a) - new Date(b));
            var ChannelFilter=data.map(item=>(item.idCustomer)).filter(onlyUnique);
            var datacontent=[];

            var data2=[ {id:'region',label:"Region" },{id:'channel',label:"Channel"}];
            
            PeriodFilter.forEach(element=>{
                data2.push({id:'moi'+moment(element).format('MM/DD/YYYY'),label:'MOI '+moment(element).format('MM/DD/YYYY')});
            })
            PeriodFilter.forEach(element=>{
                data2.push({id:'inv'+moment(element).format('MM/DD/YYYY'),label:'Total Inventory '+moment(element).format('MM/DD/YYYY')});
            })

            ChannelFilter.forEach(element=>{
                var res=[];
                var filter=data.filter((i)=>i.idCustomer==element).sort((a, b) => new Date(a.period) - new Date(b.period));
                
                filter.forEach(f=>{
                    var moikey="moi"+moment(f.period).format('MM/DD/YYYY');
                    var invkey="inv"+moment(f.period).format('MM/DD/YYYY');
                    
                    res[moikey]=f.moi;
                    res[invkey]=numberFormatComma(f.totalinventory);
                })
                res["channel"]=filter[0].nameCustomer;
                res["region"]=filter[0].country;
                datacontent.push(res);
            })
            setdatatable(datacontent);
            setheadertable(data2);
            downloadFile("inventoryreport.xlsx");
        }
    const tableresult=()=>{
        if(headertable.length>0){
            return <>
                 <Table
                    columns={headertable}
                    data={datatable}
                />
                 <Button leadingIcon={<IconDownload />} onClick={downloadReport}>
                    Download Report
                </Button>
            </>
        }else{
            return <></>;
        }
        
    }
 
    return (<>
        <Row>
            <Col md={3}>
                <Card content={
                    <>
                    <Row>
                        <Col style={{paddingBottom:"1vh"}}>
                            <Select
                                options={selectelement}
                                separateLabel
                                id="Customer"
                                label="Customer Filter"
                                value={[customer]}
                                onClear={() => setcustomer()}
                                onChange={({ value: v }) =>{
                                    setcustomer(v);
                                } }
                            />
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col style={{paddingBottom:"1vh"}}>
                            <DatePicker
                                enableOutsideDays
                                endDate={endDate}
                                endDateLabel="End Date"
                                endDatePlaceholder="mm/dd/yyyy"
                                onChange={handleOnDateChange3}
                                range
                                startDate={startDate}
                                startDateLabel="Start Date"
                                monthYearNavigation
                                startDatePlaceholder="mm/dd/yyyy"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{paddingBottom:"1vh"}}> 
                            <Select 
                                options={[{value:"Yes",label:"Yes"},{value:"No",label:"No"}]}
                                id="click"
                                label="Click Charge Inventory Ser4"
                                value={[Clickinventory]}
                                onClear={() => setClickinventory()}
                                onChange={({ value: v }) =>{
                                    setClickinventory(v);
                                } }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                                <Button loading={inload} onClick={report}>Generate Report</Button>
                        </Col>
                    </Row>
                    
                    
                    
                    
                    </>
                } appearance="dropShadow"
                style={{ padding: '20px' }}
                />
            </Col>
            <Col md={9}>
                <Card content={<>
                    {tableresult()}
                    </>
                    /*<>
                        <Table
                        columns={headertable}
                        data={null}
                        />
                    </>*/
                } appearance="dropShadow"
                style={{ padding: '20px' }}
                />
            </Col>
        </Row>
        
        
    </>);
}
export default InventorReport;